<template>
  <b-container class="mt-5">
    <b-row>
      <b-col>
        <b-card header="Create new event">
          <b-form @submit.prevent="onSubmit">
            <b-form-group id="name-label" label="Name:" label-for="name" label-cols-md="3">
              <b-form-input id="name" v-model="name" type="text" required placeholder="Enter event name"></b-form-input>
            </b-form-group>
            <b-form-group label="Allow movie suggestions" label-cols-md="3">
              <b-form-checkbox v-model="allowMovieSuggestions" name="allowMovieSuggestions" ></b-form-checkbox>
            </b-form-group>
            <b-form-group id="date-label" label="Date:" label-for="date" label-cols-md="3">
              <b-form-input id="date" v-model="date" type="datetime-local" required placeholder="Enter event date"></b-form-input>
            </b-form-group>
            <b-form-group id="place-label" label="Place:" label-for="place" label-cols-md="3">
              <b-row>
                <b-col cols="12" md="7">
                  <gmap-autocomplete class="form-control mb-3" placeholder="Enter location" @place_changed="setEventLocation" />
                </b-col>
                <b-col cols="12" md="5">
                  <b-form-group>
                    <b-form-radio-group id="marker-types" v-model="currentMarker" :options="['Event', 'Parking', 'Public Transport']" buttons button-variant="primary"></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <GmapMap ref="mapping" :center="center" :zoom="14" map-type-id="terrain" style="width: 100%; height: 300px" @click="setMarker">
                  <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :label="index" :clickable="true" :draggable="true" @click="center=m.position" />
                </GmapMap>
              </b-row>
            </b-form-group>
            <b-button type="submit" variant="primary">Create Event!</b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {mapState} from 'vuex'
import {gmapApi} from 'vue2-google-maps'
import firebase from 'firebase'

export default {
    mounted() {
      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(position =>{
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
        });
      }
    },
    computed: {
      google: gmapApi,
      ...mapState(['user', 'displayName']),
    },
    data() {
      return {
        allowMovieSuggestions: false,
        name: '',
        date: '',
        center: {lat: 0, lng: 0},
        eventAddress: '',
        markers: {
          'Event': {},
          'Parking': {},
          'Public Transport': {},
        },
        currentMarker: 'Event',
        getMap:this.$refs.mapping,
        description:'',
        latLng: {},
        place:null
      }
    },
    methods: {
      async onSubmit() {
        //firebase.database.enableLogging(true)
        const evt = {
          allowMovieSuggestions: this.allowMovieSuggestions,
          datetime: this.date,
          eventAddress: this.eventAddress,
          eventLocation: new firebase.firestore.GeoPoint(this.markers['Event'].position.lat, this.markers['Event'].position.lng),
          name: this.name,
          organizerId: this.user.uid,
          organizer: this.displayName,
          parkingLocation: new firebase.firestore.GeoPoint(this.markers['Parking'].position.lat, this.markers['Parking'].position.lng),
          publicTransportLocation: new firebase.firestore.GeoPoint(this.markers['Public Transport'].position.lat, this.markers['Public Transport'].position.lng),
        }
        firebase.firestore().collection('events').add(evt).then(ref => {
          this.$router.push('/event/' + ref.id)
        })

      },
      setDescription(description){
        this.description = description
      },

      setEventLocation(place){
        this.markers['Event'] = {
          position: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        }
        const geocoder = new this.google.maps.Geocoder()
        geocoder.geocode({
          location: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        }, (res, status) => {
          this.eventAddress = res[0].formatted_address
        })
        this.$refs.mapping.$mapPromise.then((map) => {
          map.panTo(this.markers['Event'].position)
        })
        this.currentMarker = 'Parking'
      },
      setCurrentMarkerType(type) {
        this.currentMarker = type
      },

      setMarker(e) {
        this.markers[this.currentMarker] = {
          position: {
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
          }
        }
        switch(this.currentMarker) {
          case 'Event':
            this.currentMarker = 'Parking'
            break
          case 'Parking':
            this.currentMarker = 'Public Transport'
            break
          case 'Public Transport':
            this.currentMarker = 'Event'
            break
        }
      }
    }
}
</script>

<style>
#map {
  display: inline-block;
  min-height: 400px;
}
</style>